/*global d3 */

export default function renderDiagramPeru({ el, diagramData, handleSelect }) {
  if (!el || !diagramData) return;

  d3.xml("/Areas/EGH/assets/img/stunting_drivers/diagram_single.svg")
    .mimeType("image/svg+xml")
    .get(function (xml) {
      const importedNode = document.importNode(xml.documentElement, true);
      const diagram = d3.select(el).each(function () {
        this.appendChild(importedNode);
      });

      // Walk categories and sections and set enabled/disabled status
      diagramData.forEach((category) => {
        const node = diagram.select(`[data-category-id=${category.id}]`).node();

        if (!node) return;

        if (
          !category.isEnabled ||
          !category.sections ||
          !category.sections.filter((s) => s.isEnabled).length
        ) {
          // set opacity
          node.style.opacity = 0.2;
          // disable section links for category
          node.querySelectorAll(".selectable").forEach((link) => {
            link.style.opacity = 0.5;
            link.classList.remove("selectable");
          });

          return;
        }

        // for enabled categories add mouse events actionable areas and events
        const categoryLinks = node.querySelectorAll(".selectable");

        categoryLinks.forEach((link) => {
          // get section link graphic data
          const linkGraphic = d3.select(link).node();
          const linkGraphicBox = linkGraphic.getBBox();

          // append actionable rectangle on top of category link
          d3.select(linkGraphic.parentNode)
            .append("rect")
            .attr("x", linkGraphicBox.x)
            .attr("y", linkGraphicBox.y)
            .attr("width", linkGraphicBox.width)
            .attr("height", linkGraphicBox.height)
            .attr("fill", "#ffffff")
            .attr("opacity", "0")
            .style("cursor", "pointer")
            .on("mouseover", () => (link.style.fill = "#FF7700"))
            .on("mouseout", () => (link.style.fill = "#0C4456"))
            .on("click", () => {
              handleSelect(category.id, 1);
            });
        });
      });
    });
}
